import {CompetitorViewModel} from "../../../domain/common/competitor/models/competitor-view-model";
import {CompetitorDomainModel} from "../../../domain/common/competitor/models/competitor-domain-model";

export class StandingWidgetCompetitorViewModel extends CompetitorViewModel {
  domainModel: CompetitorDomainModel;

  get name(): String {
    return this.domainModel.shortName || this.domainModel.name;
  }
}



